module.exports = __webpack_public_path__ + "static/media/image-1200.7ab8ed8f.jpg";